import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { DateTime } from 'luxon'
import { http, HttpResponse } from 'msw'

export const getCreditNote = http.get<object, object, shoppingApi.CreditNoteResult>(apiBaseUrl + '/credit/note', async () => {
  const getCreditNoteResponse = {
    note: [
      {
        amount: -1000,
        date: DateTime.now().toISO(),
        description: 'Assegno di benvenuto',
      },
      {
        amount: 500,
        date: DateTime.now().toISO(),
        description: 'Bonus di fedeltà',
      },
      {
        amount: 100,
        date: DateTime.now().toISO(),
        description: 'Bonus di benvenuto',
      },
    ],
  }
  return HttpResponse.json(getCreditNoteResponse, { status: 200 })
})
